/*
 *
 * SummaryQuestions saga
 *
 */

import { call, put, takeLatest } from "redux-saga/effects"

import { GET_LIST_COUNT_QUESTIONS_WATCHER } from "./constants"

import {
  getListCountQuestionsSuccess,
  getListCountQuestionsFailed,
} from "./actions"
import Axios from "axios"
import { LOCAL_TOKEN } from "../../../utils/storage"
import { validate } from "../../../utils/functions"

function getListCountQuestionsApi(payload) {
  const segmentParam = !validate.empty(payload.id_segment)
    ? `&id_segment=${payload.id_segment}`
    : ""
  return Axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${payload.id_measure}/questions/amounts?f${segmentParam}`,
    params: { id_segment: payload.id_segment },
  })
}

export function* getListCountQuestionsSaga(action) {
  try {
    const { data } = yield call(getListCountQuestionsApi, action.payload)
    yield put(getListCountQuestionsSuccess(data))
  } catch (e) {
    yield put(getListCountQuestionsFailed())
  }
}

// Individual exports for testing
export default function* widgetSummaryQuestionsSaga() {
  yield takeLatest(GET_LIST_COUNT_QUESTIONS_WATCHER, getListCountQuestionsSaga)
}
